export default __webpack_public_path__ + "static/media/finding-the-missing-links.dbc8dc9c.jpg";